export var editorMode = 'Editor';
export var previewMode = 'Preview';
export var siteMode = 'Site';
export var desktopMode = 'Desktop';
export var mobileMode = 'Mobile';
export var CSREnv = 'client';
export var SSREnv = 'backend';
//# sourceMappingURL=constants.js.map